import { Table } from 'antd';
import React, { Component } from 'react';
import DownloadDialog from '../Download';
import { GraphWrapper } from '@/components/Graph';
import { keyEffect30Days, traffic7Days } from '@/components/DataEffect/GraphConfig';
import './index.less';
;
;
const columnArr = [{
        title: '桶名',
        key: 'bucketName',
        dataIndex: 'bucketName',
    }, {
        title: '分桶方法',
        key: 'splitFunc',
        dataIndex: 'splitFunc',
    }, {
        title: '流量比例',
        key: 'splitRate',
        dataIndex: 'splitRate',
    }, {
        title: '分桶更新时间',
        key: 'splitTime',
        dataIndex: 'splitTime',
    }, {
        title: '模型更新时间',
        key: 'modelUpdateTime',
        dataIndex: 'modelUpdateTime',
    }];
export default class TrafficBuckets extends Component {
    constructor(props) {
        super(props);
        this.state = {
            bucketList: [],
            columns: [],
        };
    }
    componentDidMount() {
        const { bucketInfo } = this.props.dataEffectValue.keyIndexs.abTestAnalyse;
        const { data, column } = bucketInfo;
        const res = [];
        // 要根据后端返回的column去判断表格展示哪些列
        for (let i = 0; i < columnArr.length; i++) {
            if (column[columnArr[i].key]) {
                res.push(columnArr[i]);
            }
        }
        this.setState({
            bucketList: data,
            columns: res,
        });
    }
    render() {
        const { bucketList, columns } = this.state;
        const { sceneCode } = this.props.dataEffectValue;
        const { traffic7DaysCfg, keyEffect30DaysCfg_CVR, keyEffect30DaysCfg_CTR, keyEffect30DaysCfg_CBRate, keyEffect30DaysCfg_ClueTransferRate } = this.props.dataEffectValue.keyIndexs.abTestAnalyse;
        return (<div className="traffic-buckets">
        <div className="data-effect-title mb_20">流量分桶</div>
        <p>分桶说明</p>
        <div className="traffic-buckets-table-box">
          {columns.length && <Table className="traffic-buckets-table" dataSource={bucketList} columns={columns} rowKey="code" loading={false} pagination={false}/>}
        </div>

        <p style={{ marginTop: '30px' }}>分桶指标</p>
        <div className="traffic-bucket-content-graphs">
          {traffic7DaysCfg && <div className="traffic-bucket-content-graphs-wrapper">
            <GraphWrapper key={1} title="近7日流量比例" config={traffic7Days(traffic7DaysCfg)}/>
            <DownloadDialog key={11} className="traffic-bucket-content-graphs-btn" type="latest7Days" sceneCode={sceneCode}/>
          </div>}
          {keyEffect30DaysCfg_CTR && <div className="traffic-bucket-content-graphs-wrapper">
            <GraphWrapper key={2} title="近30日关键指标-CTR" config={keyEffect30Days(keyEffect30DaysCfg_CTR)}/>
            <DownloadDialog key={12} className="traffic-bucket-content-graphs-btn" type="keyEffectCTR" sceneCode={sceneCode}/>
          </div>}
        </div>
        <div className="traffic-bucket-content-graphs">
          {keyEffect30DaysCfg_CVR && <div className="traffic-bucket-content-graphs-wrapper">
            <GraphWrapper key={3} title="近30日关键指标-CVR" config={keyEffect30Days(keyEffect30DaysCfg_CVR)}/>
            <DownloadDialog key={13} className="traffic-bucket-content-graphs-btn" type="keyEffectCVR" sceneCode={sceneCode}/>
          </div>}
          {keyEffect30DaysCfg_CBRate && <div className="traffic-bucket-content-graphs-wrapper">
            <GraphWrapper key={4} title="近30日关键指标-充保率" config={keyEffect30Days(keyEffect30DaysCfg_CBRate)}/>
            <DownloadDialog key={14} className="traffic-bucket-content-graphs-btn" type="keyEffectCB" sceneCode={sceneCode}/>
          </div>}
          {keyEffect30DaysCfg_ClueTransferRate && <div className="traffic-bucket-content-graphs-wrapper">
            <GraphWrapper key={4} title="近30日关键指标-线索转化率" config={keyEffect30Days(keyEffect30DaysCfg_ClueTransferRate)}/>
            <DownloadDialog key={14} className="traffic-bucket-content-graphs-btn" type="keyEffectClueTransferRate" sceneCode={sceneCode}/>
          </div>}
        </div>
      </div>);
    }
}
